module.exports = __webpack_public_path__ + "img/9791159920141.6408c6ed.jpg";